module.exports = __webpack_public_path__ + "img/helpdetail2.5c7ff0e0.png";